
export const IsAuthenticatedLocally = ( isBrowser ) => {
  if ( !isBrowser() ) {
    return
  }
  return localStorage.getItem( "isLoggedIn" ) === "true"
}

export default IsAuthenticatedLocally